import http from './reddit'
// periodManagement
export default {
  // 取得 期数列表
  list: (gameid) => http.Get(`${http.url.six}/period/${gameid}`),
  // 修改 期数改為停押非特码
  autostopnos: (gameid, data) => http.Post(`${http.url.six}/autostopnos/${gameid}`, data),
  autoopen: (gameid, data) => http.Post(`${http.url.six}/autoopen/${gameid}`, data),
  closePeriod: (gameid, data) => http.Post(`${http.url.six}/pdcl/${gameid}`, data),
  NowAddPeriodData: (gameid) => http.Get(`${http.url.six}/pddtime/${gameid}`),
  addPeriodDate: (gameid, data) => http.Post(`${http.url.six}/pdad/${gameid}`, data),
  getPeriodDate: (gameid, id = '') => http.Get(`${http.url.six}/pduge/${gameid}/${id}`),
  modifyPeriod: (gameid, data) => http.Post(`${http.url.six}/pdupo/${gameid}`, data),
  removePeriod: (gameid, data) => http.Post(`${http.url.six}/pddpo/${gameid}`, data)
}